import { Navigate } from "react-router-dom";
import * as React from 'react'

import Persistance from "./Persistence";

export interface Props {
    children: React.ReactNode
}
  
export interface State {
}

Persistance.setValues()

export class ProtectedRoute extends React.Component<Props, any> {

  public render(): React.ReactNode {
    const user: number = Persistance.getUserId()
    if (!user || user === 0) {
      // user is not authenticated
      return <Navigate to="/login" />;
    }
    return this.props.children
  }  
  
}

export default ProtectedRoute